module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_6005.8bee92b0.png";